export enum customerTypeEnum {
  Personal = "PERSONAL",
  Corporate = "CORPORATE",
}
